export default __webpack_public_path__ + "static/media/Arrow-right-blue.3560b3d5.svg";